import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';

import {
  SubTabsType,
  useEarningsInsightDrawer,
} from '../useEarningsInsightDrawer';
import { DocumentModal } from './components/document-modal/DocumentModal';
import { EarningsPreview } from './earnings-preview/EarningsPreview';
import { EarningsRecap } from './earnings-recap/EarningsRecap';
import * as S from './EarningsInsightWidget.styles';

export const EarningsInsightWidget = () => {
  const { t } = useTranslation(['earnings']);
  const { switchTab, activeTabIndex, activeTab } = useEarningsInsightDrawer();
  const [resetKey, setResetKey] = useState(0);

  return (
    <S.Root>
      <DocumentModal />
      <S.StyledButtonGroup
        labels={[
          t('earnings:earningsInsight.drawer.earningsPreview.title'),
          t('earnings:earningsInsight.drawer.earningsRecap.title'),
        ]}
        onClick={idx => {
          switchTab(idx);
          setResetKey(resetKey + 1);
        }}
        activeIndex={activeTabIndex}
      />
      <ErrorBoundaryWrapper resetKeys={[resetKey]}>
        {activeTab === SubTabsType.Preview ? (
          <EarningsPreview />
        ) : (
          <EarningsRecap />
        )}
      </ErrorBoundaryWrapper>
    </S.Root>
  );
};
